<template>
	<b-row style="padding: 10px; background-color: #f8f9fa;">

		<b-col xs="12" sm="12" md="12" lg="12" xl="3">
			<div class="sa-documento-meta-wrapper">
				<div class="sa-documento-meta-item">
					<div class="sa-documento-meta-icon-wrapper create">
						<b-icon icon="plus-circle-fill"></b-icon>
					</div>
					<div class="sa-documento-meta-text">
						<span class="sa-documento-meta-label">Creato il</span>
						<span class="sa-data">
							<span class="sa-documento-meta-date">{{ formatDateTime(data.createDate) }}</span>
						</span>
					</div>
				</div>
			</div>
		</b-col>
		<b-col xs="12" sm="12" md="12" lg="12" xl="3">
			<div class="sa-documento-meta-wrapper">
				<div class="sa-documento-meta-item">
					<div class="sa-documento-meta-icon-wrapper create">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
							class="bi bi-person-fill-add" viewBox="0 0 16 16">
							<path
								d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
							<path
								d="M2 13c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4" />
						</svg>
					</div>
					<div class="sa-documento-meta-text">
						<span class="sa-documento-meta-label">Creato da</span>

						<span class="sa-data">
							<b-link id="userInformationCreateUser" @click="getUserInfo(data.createUser, $event)">{{
								data.createUser }}</b-link>
						</span>
					</div>
				</div>
			</div>
		</b-col>

		<b-col xs="12" sm="12" md="12" lg="12" xl="3" style="">
			<div class="sa-documento-meta-wrapper">
				<div class="sa-documento-meta-item">
					<div class="sa-documento-meta-icon-wrapper update">
						<b-icon icon="pencil-fill"></b-icon>
					</div>
					<div class="sa-documento-meta-text">
						<span class="sa-documento-meta-label">Modificato il</span>
						<span class="sa-data">
							<span class="sa-documento-meta-date">{{ formatDateTime(data.updateDate) }}</span>
						</span>
					</div>
				</div>
			</div>
		</b-col>

		<b-col xs="12" sm="12" md="12" lg="12" xl="3">
			<div class="sa-documento-meta-wrapper">
				<div class="sa-documento-meta-item">
					<div class="sa-documento-meta-icon-wrapper update">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
							class="bi bi-person-fill-gear" viewBox="0 0 16 16">
							<path
								d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4m9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
						</svg>
					</div>
					<div class="sa-documento-meta-text">
						<span class="sa-documento-meta-label">Modificato da</span>
						<span class="sa-data">
							<b-link id="userInformationUpdateUser" @click="getUserInfo(data.updateUser, $event)">{{
								data.createUser }}</b-link>
						</span>
					</div>
				</div>
			</div>
		</b-col>

		<b-popover ref="popover" target="userInformationCreateUser" title="User Information" triggers="focus"
			class="sa-popover">
			<p>
				{{ this.$i18n.t("anagrafica.lblLastName") }}:
				<strong style="white-space: nowrap">{{ item.lastname }}</strong>
			</p>
			<p>
				{{ this.$i18n.t("anagrafica.lblFirstName") }}:
				<strong style="white-space: nowrap">{{ item.firstname }}</strong>
			</p>
			<p>
				{{ this.$i18n.t("anagrafica.lblEmail") }}:
				<strong style="white-space: nowrap">{{ item.email }}</strong>
			</p>
		</b-popover>
		<b-popover ref="popover" target="userInformationUpdateUser" title="User Information" triggers="focus">
			<p>
				{{ this.$i18n.t("anagrafica.lblLastName") }}:
				<strong style="white-space: nowrap">{{ item.lastname }}</strong>
			</p>
			<p>
				{{ this.$i18n.t("anagrafica.lblFirstName") }}:
				<strong style="white-space: nowrap">{{ item.firstname }}</strong>
			</p>
			<p>
				{{ this.$i18n.t("utenti.lblGroup") }}:
				<strong style="white-space: nowrap">{{ item.profilo }}</strong>
			</p>
			<p>
				{{ this.$i18n.t("anagrafica.lblEmail") }}:
				<strong style="white-space: nowrap">{{ item.email }}</strong>
			</p>
		</b-popover>
	</b-row>
	<!-- <div class="row">
        <div class="col">
            <strong> {{ this.$i18n.t("global.lblCreateDate") }} </strong><br />
            <span class="sa-form-label">{{ formatDateTime(data.createDate) }}</span>
        </div>
        <div class="col">
            <label> {{ this.$i18n.t("global.lblCreateUser") }} </label>
            <span class="sa-form-label">
                <b-link id="userInformationCreateUser" @click="getUserInfo(data.createUser, $event)">{{ data.createUser }}</b-link>
            </span>
        </div>
        <div class="col">
            <strong> {{ this.$i18n.t("global.lblUpdateDate") }} </strong><br />
            <span class="sa-form-label">{{ formatDateTime(data.updateDate) }}</span>
        </div>
        <div class="col">
            <strong> {{ this.$i18n.t("global.lblUpdateUser") }} </strong><br />
            <span class="sa-form-label">
                <b-link id="userInformationUpdateUser" @click="getUserInfo(data.updateUser, $event)">{{ data.updateUser }}</b-link>
            </span>
        </div>
        <b-popover ref="popover" target="userInformationCreateUser" title="User Information" triggers="focus" class="sa-popover">
            <p>
                {{ this.$i18n.t("anagrafica.lblLastName") }}: <strong style="white-space: nowrap">{{ item.lastname }}</strong>
            </p>
            <p>
                {{ this.$i18n.t("anagrafica.lblFirstName") }}: <strong style="white-space: nowrap">{{ item.firstname }}</strong>
            </p>
            <p>
                {{ this.$i18n.t("anagrafica.lblEmail") }}: <strong style="white-space: nowrap">{{ item.email }}</strong>
            </p>
        </b-popover>
        <b-popover ref="popover" target="userInformationUpdateUser" title="User Information" triggers="focus">
            <p>
                {{ this.$i18n.t("anagrafica.lblLastName") }}: <strong style="white-space: nowrap">{{ item.lastname }}</strong>
            </p>
            <p>
                {{ this.$i18n.t("anagrafica.lblFirstName") }}: <strong style="white-space: nowrap">{{ item.firstname }}</strong>
            </p>
            <p>
                {{ this.$i18n.t("utenti.lblGroup") }}: <strong style="white-space: nowrap">{{ item.profilo }}</strong>
            </p>
            <p>
                {{ this.$i18n.t("anagrafica.lblEmail") }}: <strong style="white-space: nowrap">{{ item.email }}</strong>
            </p></b-popover
        >
    </div> -->
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import axios from "axios";
export default {
	mixins: [UtilityMixin],
	props: {
		data: {},
	},
	data() {
		return {
			pathResource: "/users/infouser",
			show: false,
			target: "userInformationUpdateUser",
			item: {},
		};
	},
	created() { },
	methods: {
		getUserInfo(data) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + data;
			axios.get(link)
				.then((response) => {
					me.item = response.data.data;
				})
				.catch(() => {
					// me.showmolalloading = false;
				});
		},
	},
};
</script>
<style scoped>
.sa-documento-meta-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.sa-documento-meta-item {
	display: flex;
	align-items: center;
	gap: 10px;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	padding: 8px 16px;
	border-radius: 8px;
	margin: 4px 4px;
	gap: 16px;
}

.sa-documento-meta-icon-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border-radius: 6px;
	font-size: 0.85rem;
}

.sa-documento-meta-icon-wrapper.create {
	background-color: #ecfdf5;
	color: #10b981;
}

.sa-documento-meta-icon-wrapper.update {
	background-color: #eff6ff;
	color: #3b82f6;
}

.sa-documento-meta-text {
	display: flex;
	flex-direction: column;
}

.sa-documento-meta-label {
	font-size: 0.65rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #64748b;
	line-height: 1;
	margin-bottom: 2px;
}

.sa-documento-meta-date {
	font-size: 0.85rem;
	color: #1e293b;
	font-weight: 600;
}
</style>
